// import { Routes, Route, Link } from 'react-router-dom';
import { strToolNameHeadline, default_tooltip_show, default_tooltip_hide } from '../Consts';
import React from 'react';

import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { genMinMaxAvgNote, genMinMaxAvgPunkte } from '../Functions';

import './StatusBlock.css';

// export function NavbarTop() {
const StatusBlock = ({ parentState, size }) => {

    // const genMinMaxAvgNote = () => {
    //     let g = parentState.grid;
    //     let gS = {
    //         "num": 0,
    //         "ming": 9999,
    //         "maxg": -1,
    //         "sumg": 0
    //     }
    //     g.forEach(item => {
    //         var grade = Number(item[item.length - 1].value);
    //         if (grade > gS.maxg) {
    //             gS.maxg = grade;
    //         }
    //         if (grade < gS.ming) {
    //             gS.ming = grade;
    //         }
    //         gS.sumg += grade;
    //         gS.num++;
    //     });
    //     if (gS.ming === 9999) {
    //         // return "Keine Daten vorhanden";
    //         // return ["Keine", "Daten", "vorhanden"];
    //         return ["", "", ""];
    //     } else {
    //         // return gS.ming + " / " + gS.maxg + " / " + Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100;;
    //         return [gS.ming, gS.maxg, Math.round(((gS.sumg / gS.num) + Number.EPSILON) * 100) / 100];
    //     }
    // }

    // const genMinMaxAvgPunkte = () => {
    //     let g = parentState.grid;
    //     let pS = {
    //         "num": 0,
    //         "minsum": 9999,
    //         "maxsum": -1,
    //         "sumsum": 0
    //     }
    //     g.forEach(item => {
    //         var sum = 0;
    //         for (var i = 2; i < item.length - 2; i++) {
    //             sum += Number(item[i].value);
    //         }
    //         if (sum > pS.maxsum) {
    //             pS.maxsum = sum;
    //         }
    //         if (sum < pS.minsum) {
    //             pS.minsum = sum;
    //         }
    //         pS.sumsum += sum;
    //         pS.num++;
    //     });
    //     if (pS.minsum === 9999) {
    //         // return "Keine Daten vorhanden";
    //         return ["", "", ""];
    //     } else {
    //         // return pS.minsum + " / " + pS.maxsum + " / " + Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100;
    //         return [pS.minsum, pS.maxsum, Math.round(((pS.sumsum / pS.num) + Number.EPSILON) * 100) / 100];
    //     }
    // }

    let maxP = genMinMaxAvgPunkte(parentState);
    let maxN = genMinMaxAvgNote(parentState);

    // let numT = parentState.taskNames[0].length - 2;
    let numT = parentState.maxPunkte[0].length - 3;

    // console.log(numT);

    // console.warn("STATUS BLOCK RERENDER", parentState)

    if (size === "small") {
        return (
            <>
                Aufgaben: {numT}
                <br />
                SchülerInnen: {parentState.grid.length}
                <br />
                Punkte: Min({maxP[0] ? maxP[0] : "0"}) Max({maxP[1] ? maxP[1] : "0"}) Avg({maxP[2] ? maxP[2] : "0"})
                <br />
                Note: Min({maxN[0] ? maxN[0] : "0"}) Max({maxN[1] ? maxN[1] : "0"}) Avg({maxN[2] ? maxN[2] : "0"})
            </>
        );
    }

    return (
        <Card bg="light" text="dark" border="dark">
            <Card.Body>
                <Card.Title as="h6">
                    Metadaten:
                </Card.Title>
                <Card.Text className="small-font">
                    {/* Aufgaben: {parentState.columns.length - 4} */}
                    Aufgaben: {numT}
                    <br />
                    SchülerInnen: {parentState.grid.length}
                    <br />
                    Punkte: Min({maxP[0] ? maxP[0] : "0"}) Max({maxP[1] ? maxP[1] : "0"}) Avg({maxP[2] ? maxP[2] : "0"})
                    <br />
                    Note: Min({maxN[0] ? maxN[0] : "0"}) Max({maxN[1] ? maxN[1] : "0"}) Avg({maxN[2] ? maxN[2] : "0"})
                </Card.Text>
            </Card.Body>
        </Card>
    )
}

export default StatusBlock;
